import { FC, useMemo } from "react";
import { Form, FormItemProps } from "antd";
import { Rule } from "antd/es/form";

interface FormTextWrapperProps extends FormItemProps {
  placeholder?: string;
  maxLength?: number;
}

export const FormTextWrapper: FC<FormTextWrapperProps> = ({
  maxLength,
  required = false,
  rules,
  children,
  placeholder,
  ...props
}) => {
  const defaultRules: Rule[] = useMemo(
    () => [
      {
        max: maxLength,
        type: "string",
        required,
        transform: (value) => value.trim(),
      },
    ],
    [required]
  );

  const itemRules = useMemo(
    () => (rules ? defaultRules.concat(rules) : defaultRules),
    [rules, defaultRules]
  );

  return (
    <Form.Item rules={itemRules} initialValue="" {...props}>
      {children}
    </Form.Item>
  );
};
